import React, { useEffect, useRef, useState } from "react";
import "./ContactUs.css";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleXmark,
  faEnvelope,
  faLocationDot,
  faMapLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { Controller } from "swiper/modules";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useForm } from "react-hook-form";
import {
  faFacebook,
  faFacebookF,
  faInstagram,
  faLinkedin,
  faLinkedinIn,
  faThreads,
  faWhatsapp,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import SuccesfullModal from "../Common_Component/SuccesfullModal/SuccesfullModal";
import { Link } from "react-router-dom";
const ContactUs = () => {
  const [modalShow, setModalShow] = React.useState(false);
  const { control, handleSubmit, getValues, setValue } = useForm();

  const onSubmit = (data) => {
    console.log(data);
  };

  const [showMap, setShowMap] = useState(false);
  const mapRef = useRef(null);

  const toggleMap = () => {
    setShowMap(!showMap);
  };

  const handleClickOutside = (event) => {
    if (mapRef.current && !mapRef.current.contains(event.target)) {
      setShowMap(false);
    }
  };

  useEffect(() => {
    if (showMap) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMap]);

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <>
      <section className="ContactUs">
        <div className="container">
          <div className="map-form-holder">
            <div className="text-holder">
              <div className="row">
                <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 col-12">
                  <div className="top-headeing">
                    <h1>
                      Let’s Connect and Take <br />
                      Your Brand to New Heights!
                    </h1>
                  </div>
                </div>
                <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12 col-12">
                  <div className="top-decription">
                    <p>
                      At <span>ReachOut Media Tech Pvt. Ltd.</span>, we are
                      always ready to assist you with your advertising needs.
                      Whether you want to discuss your next big campaign or
                      explore how our services can help grow your business,
                      we’re here to help
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="main-div">
              <div className="row">
                <div className="col-xl-8 col-lg-7 col-md-7 col-sm-12 col-12">
                  <div className="left-card">
                    <div className="form-holder">
                      <div className="form-headeing">
                        <h2>Let’s Start a Conversation</h2>
                      </div>
                      <div className="form">
                        <Form onSubmit={handleSubmit(onSubmit)}>
                          <div className="main-form-section mt-4">
                            <div className="input-div">
                              <Form.Group>
                                <InputGroup>
                                  <Form.Control
                                    type="text"
                                    placeholder="Your Name"
                                  />
                                </InputGroup>
                              </Form.Group>
                            </div>

                            <div className="input-div">
                              <Form.Group>
                                <InputGroup>
                                  <Form.Control
                                    type="text"
                                    placeholder="Email"
                                  />
                                </InputGroup>
                              </Form.Group>
                            </div>

                            <div className="input-div">
                              <Form.Group>
                                <InputGroup>
                                  <Form.Control
                                    type="text"
                                    placeholder="Subject"
                                  />
                                </InputGroup>
                              </Form.Group>
                            </div>

                            <div className="input-div">
                              <Form.Group>
                                {/* <Controller
                                                            name="contact_no"
                                                            control={control}
                                                            render={({ field }) => (
                                                                <div style={{ position: 'relative' }}> */}
                                <PhoneInput
                                  country={"in"}
                                  searchPlaceholder="Enter Mobile Number"
                                  value={getValues("contact_no")} // Manually bind value
                                  onChange={(phone) =>
                                    setValue("contact_no", phone)
                                  } // Manually handle change
                                  inputProps={{
                                    searchPlaceholder: "Enter Mobile Number", // Use inputProps to pass the placeholder
                                  }}
                                />
                                {/* </div>
                                                            )}
                                                        /> */}
                              </Form.Group>
                            </div>

                            <div className="input-div">
                              <Form.Group>
                                <InputGroup>
                                  <Form.Control
                                    type="text"
                                    placeholder="Your Message"
                                  />
                                </InputGroup>
                              </Form.Group>
                            </div>
                            <div className="btn-div">
                              <Button
                                className="submit-btn"
                                type="submit"
                                onClick={() => setModalShow(true)}
                              >
                                Send Message
                              </Button>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-5 col-md-5 col-sm-12 col-12 right-main-card">
                  <div className="right-card">
                    <div className="main-card">
                      <h5>Get in Touch With Us</h5>
                      <div className="contact-div">
                        <div className="contact-holder">
                          <div className="icon-holder">
                            <div className="circle-div">
                              <i class="fa-solid fa-phone">
                                <FontAwesomeIcon icon={faPhone} />
                              </i>
                            </div>
                          </div>
                          <div className="info-holder">
                            <p>
                              Toll-Free: 1800-268-2424 / <br /> +91 8484024823
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="contact-div">
                        <div className="contact-holder">
                          <div className="icon-holder">
                            <div className="circle-div">
                              <i class="fa-solid fa-phone">
                                <FontAwesomeIcon icon={faEnvelope} />
                              </i>
                            </div>
                          </div>
                          <div className="info-holder">
                            <p>info@reachoutmediatech.com</p>
                          </div>
                        </div>
                      </div>

                      <div className="contact-div">
                        <div className="contact-holder">
                          <div className="icon-holder">
                            <div className="circle-div">
                              <i class="fa-solid fa-phone">
                                <FontAwesomeIcon icon={faLocationDot} />
                              </i>
                            </div>
                          </div>
                          <div className="info-holder">
                            <p>
                              6th Floor, Gandharv Empire, Raskar Chowk,
                              Magarpatta, Pune, Maharashtra, 411036
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="contact-div">
                        <div className="contact-holder">
                          <div className="icon-holder">
                            <div className="circle-div">
                              <i class="fa-solid fa-phone">
                                <FontAwesomeIcon icon={faMapLocationDot} />
                              </i>
                            </div>
                          </div>
                          <div className="info-holder" onClick={toggleMap}>
                            <p>Find Us on map</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="social-media-main-card">
                      <h5>Follow Us on Social Media</h5>

                      <div className="contact-div">
                        <div className="contact-holder ">
                          <Link
                            className="d-flex align-items-center"
                            target="_black"
                            to={
                              "https://www.facebook.com/profile.php?id=61567246887800"
                            }
                          >
                            <div className="icon-holder">
                              <div className="circle-div">
                                <i class="fa-solid fa-phone">
                                  <FontAwesomeIcon icon={faFacebookF} />
                                </i>
                              </div>
                            </div>

                            <div className="info-holder">
                              <p>Facebook</p>
                            </div>
                          </Link>
                        </div>
                      </div>

                      <div className="contact-div">
                        <div className="contact-holder">
                          <Link
                            className="d-flex align-items-center"
                            target="_black"
                            to={
                              "https://www.instagram.com/reachoutmediatech/?hl=en"
                            }
                          >
                            <div className="icon-holder">
                              <div className="circle-div">
                                <i class="fa-solid fa-phone">
                                  <FontAwesomeIcon icon={faInstagram} />
                                </i>
                              </div>
                            </div>

                            <div className="info-holder">
                              <p>Instagram</p>
                            </div>
                          </Link>
                        </div>
                      </div>

                      <div className="contact-div">
                        <div className="contact-holder">
                          <Link
                            className="d-flex align-items-center"
                            target="_black"
                            to={"https://www.linkedin.com/company/104845041/"}
                          >
                            <div className="icon-holder">
                              <div className="circle-div">
                                <i class="fa-solid fa-phone">
                                  <FontAwesomeIcon icon={faLinkedinIn} />
                                </i>
                              </div>
                            </div>

                            <div className="info-holder">
                              <p>Linkedin</p>
                            </div>
                          </Link>
                        </div>
                      </div>

                      <div className="contact-div">
                        <div className="contact-holder ">
                          <Link
                            className="d-flex align-items-center"
                            target="_black"
                            to={"https://www.youtube.com/@ReachOutMediaTech"}
                          >
                            <div className="icon-holder">
                              <div className="circle-div">
                                <i class="fa-solid fa-phone">
                                  <FontAwesomeIcon icon={faYoutube} />
                                </i>
                              </div>
                            </div>

                            <div className="info-holder">
                              <p>Youtube</p>
                            </div>
                          </Link>
                        </div>
                      </div>

                      {/* <div className="contact-div">
                        <div className="contact-holder ">
                          <Link
                            className="d-flex align-items-center"
                            target="_black"
                            to={
                              "https://www.facebook.com/profile.php?id=61567246887800"
                            }
                          >
                            <div className="icon-holder">
                              <div className="circle-div">
                                <i class="fa-solid fa-phone">
                                  <FontAwesomeIcon icon={faThreads} />
                                </i>
                              </div>
                            </div>

                            <div className="info-holder">
                              <p>threads</p>
                            </div>
                          </Link>
                        </div>
                      </div> */}

                      {/* <div className="contact-div">
                        <div className="contact-holder">
                          <Link
                            target="_black"
                            to={"https://wa.me/918484024823"}
                          >
                            <div className="icon-holder">
                              <div className="circle-div">
                                <i class="fa-solid fa-phone">
                                  <FontAwesomeIcon icon={faWhatsapp} />
                                </i>
                              </div>
                            </div>

                            
                          </Link>
                        </div>
                      </div> */}

                      {/* <div className="contact-div">
                        <div className="contact-holder">
                          <Link
                            target="_black"
                            to={"https://www.threads.net/@reachoutmediatech"}
                          >
                            <div className="icon-holder">
                              <div className="circle-div">
                                <i class="fa-solid fa-phone">
                                  <FontAwesomeIcon icon={faThreads} />
                                </i>
                              </div>
                            </div>

                            
                          </Link>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {showMap && (
              <div className="close-btn" onClick={() => setShowMap(false)}>
                <FontAwesomeIcon icon={faCircleXmark} />
              </div>
            )}

            <div
              ref={mapRef}
              className={`gmap_canvas swing-top-fwd ${showMap ? "show" : ""}`}
            >
              <iframe
                class="gmap_iframe"
                frameborder="0"
                scrolling="no"
                marginheight="0"
                marginwidth="0"
                src="https://maps.google.com/maps?width=600&height=400&hl=en&q=6th Floor, Gandharva Empire, Raskar Chowk, Magarpatta, Pune, Maharashtra, 411036&t=&z=15&ie=UTF8&iwloc=B&output=embed"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
      <SuccesfullModal
        message={"Form submitted successfully !"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default ContactUs;
